export default __webpack_public_path__ + "static/media/greenArrow.d96d1777.svg";